import FormGrouper from '@sophocles/components/FormGrouper/FormGrouper';

export default FormGrouper;
